import { useCallback, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useBoolean, useSetState } from 'react-use'

import { TablesAPI } from '@makyoapp/makyo-sdk'
import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { Button, ButtonVariant, Field, Label, Modal } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useReqError } from '@/hooks/useReqError'
import { SaveButton } from '@/components/SaveButton'

import { useGridV2Context } from '../../contexts/GridV2Context'
import { ColumnDd } from '../fields/ColumnDd'

interface UserTableColState {
  email: string
  name: string
  photo: string
  phone: string
}

export default function MarkAsUserTableModal() {
  const { t } = useTranslation()

  const { userTable } = useDbClientContext()
  const { table } = useGridV2Context()

  const [isLoading, setIsLoading] = useBoolean(false)
  const [markTableAsUser, setMarkTableAsUser] = useState(false)

  const onHide = useCallback(() => setMarkTableAsUser(false), [setMarkTableAsUser])

  const [cols, setCols] = useSetState<UserTableColState>({
    email: '',
    name: '',
    photo: '',
    phone: '',
  })

  const printAPIError = useReqError()

  return markTableAsUser ? (
    <Modal show={true} onHide={onHide}>
      <Modal.Header onCloseClick={onHide}>
        <Trans>Assign as User Table</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className='modal-md'>
          <div className='text-base mb-2'>
            <Trans>Would you like to make this table the User Table?</Trans>
          </div>
          <div className='text-light'>
            <Trans>
              If you do, any other tables currently assigned as User Table will no longer be the User Table.
            </Trans>
          </div>
          <hr className='hr my-4' />
          <div>
            <div className='mb-4'>
              <Trans>Choose the email, name, and photo columns</Trans>
            </div>
            <Field>
              <Label required>
                <Trans>Email</Trans>
              </Label>
              <ColumnDd
                types={[ColumnTypes.Email]}
                selected={cols.email}
                id='mark-as-user-table-email-col'
                onChange={(opt) => setCols({ email: opt.id })}
              />
            </Field>
            <Field>
              <Label>
                <Trans>Name</Trans>
              </Label>
              <ColumnDd
                types={[ColumnTypes.Text]}
                selected={cols.name}
                id='mark-as-user-table-name-col'
                onChange={(opt) => setCols({ name: opt.id })}
              />
            </Field>
            <Field>
              <Label>
                <Trans>Photo</Trans>
              </Label>
              <ColumnDd
                types={[ColumnTypes.URL, ColumnTypes.Image]}
                selected={cols.photo}
                id='mark-as-user-table-photo-col'
                onChange={(opt) => setCols({ photo: opt.id })}
              />
            </Field>
            <Field>
              <Label>
                <Trans>Phone</Trans>
              </Label>
              <ColumnDd
                types={[ColumnTypes.Phone]}
                selected={cols.phone}
                id='mark-as-user-table-phone-col'
                onChange={(opt) => setCols({ phone: opt.id })}
              />
            </Field>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='justify-between'>
        <Button variant={ButtonVariant.Outlined} onClick={onHide}>
          <Trans>Cancel</Trans>
        </Button>
        <SaveButton
          disabled={!Boolean(cols.email)}
          isLoading={isLoading}
          label={t('Yes, Continue')}
          onClick={() => {
            if (!table) return

            setIsLoading(true)
            TablesAPI.ReqMakeUserTable(table.id, {
              _NameColumnID: cols.name,
              _EmailColumnID: cols.email,
              _PhoneColumnID: cols.phone,
              _PhotoColumnID: cols.photo,
            })
              .then(() => {
                if (userTable) {
                  // todo:update old user table
                  //   updateTable(userTable.id, (tbl) => {
                  //     const cols = [...tbl.columns]
                  //     cols.map((c) => {
                  //       return {
                  //         ...c,
                  //         userAttr: ColumnUserTableAttributes.None,
                  //         isUserEmail: false,
                  //         isUserPhoto: false,
                  //         isUserName: false,
                  //         isUserPhone: false,
                  //       }
                  //     })
                  //     return {
                  //       ...tbl,
                  //       isUserTable: false,
                  //       columns: cols,
                  //     }
                  //   })
                }
                // todo: update new table
                // updateTable(table.id, (tbl) => {
                //   const tCols = [...tbl.columns]
                //   for (const c of Object.keys(cols)) {
                //     const colId = cols[c as UserTableColStateKey]
                //     if (colId) {
                //       switch (c) {
                //         case 'name':
                //           const nIdx = tCols.findIndex((tc) => tc.id === colId)
                //           if (nIdx !== -1) {
                //             tCols[nIdx].userAttr = ColumnUserTableAttributes.Name
                //             tCols[nIdx].isUserName = true
                //           }
                //           break
                //         case 'email':
                //           const eIdx = tCols.findIndex((tc) => tc.id === colId)
                //           if (eIdx !== -1) {
                //             tCols[eIdx].userAttr = ColumnUserTableAttributes.Email
                //             tCols[eIdx].isUserEmail = true
                //           }
                //           break
                //         case 'phone':
                //           const phIdx = tCols.findIndex((tc) => tc.id === colId)
                //           if (phIdx !== -1) {
                //             tCols[phIdx].userAttr = ColumnUserTableAttributes.Phone
                //             tCols[phIdx].isUserPhone = true
                //           }
                //           break
                //         case 'photo':
                //           const phoIdx = tCols.findIndex((tc) => tc.id === colId)
                //           if (phoIdx !== -1) {
                //             tCols[phoIdx].userAttr = ColumnUserTableAttributes.Photo
                //             tCols[phoIdx].isUserPhoto = true
                //           }
                //           break
                //       }
                //     }
                //   }
                //   return {
                //     ...tbl,
                //     isUserTable: true,
                //     columns: tCols,
                //   }
                // })
              })
              .catch(printAPIError)
              .finally(() => {
                setIsLoading(false)
                setCols({
                  name: '',
                  email: '',
                  phone: '',
                  photo: '',
                })
                setMarkTableAsUser(false)
              })
          }}
        />
      </Modal.Footer>
    </Modal>
  ) : null
}
